@if (invoicePayments().length) {
  <section class="mx-auto max-w-screen-sm px-5 pb-6 lg:w-8/12 lg:max-w-none lg:px-0">
    <h2 class="font-accent text-lg font-bold text-neutral-800">
      {{ title() | translate }}
    </h2>

    <ul class="mt-3 space-y-2">
      @for (payment of invoicePayments(); track payment.id) {
        <li>
          <a
            class="block"
            [link]="payment.invoice_file_path"
          >
            <app-button-atom
              [type]="'outlined'"
              [size]="'M'"
              [full]="true"
              [label]="buildButtonLabel(payment)"
              [icon]="'icon-download'"
              [iconOnRight]="true"
            ></app-button-atom>
          </a>
        </li>
      }
    </ul>
  </section>
}
